
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/literasi-keuangan/cara-cerdas/[slug]",
      function () {
        return require("private-next-pages/literasi-keuangan/cara-cerdas/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/literasi-keuangan/cara-cerdas/[slug]"])
      });
    }
  